import styled from 'styled-components/macro';

import { extraSmallScreens, smallScreens } from '../../common/fontElements';
import * as colors from 'components/common/colorConstants';

export const Container = styled.div`
  overflow-y: auto;
  height: 100%;
  font-size: 13px;
`;

export const Description = styled.div`
  padding-top: ${(props) => (props.noBottomSection ? '100px' : '60px')};
  width: 370px;
  margin: 0px auto;
  @media (max-height: ${smallScreens}) {
    padding-top: ${(props) => (props.noBottomSection ? '80px' : '50px')};
  }
  @media (max-height: ${extraSmallScreens}) {
    padding-top: ${(props) => (props.noBottomSection ? '60px' : '40px')};
  }
`;

export const SimilarTicketsDescription = styled.div`
  padding-top: 40px;
  width: 90%;
  margin: 0px auto;
  @media (max-height: ${smallScreens}) {
    padding-top: 50px;
  }
`;

export const MacroWizard = styled.div`
  padding: ${(props) => (props.recommendationsActive ? '35px 10%' : '35px 10% 50px')};
  margin: 0px auto;
  display: block;
  @media (max-height: ${smallScreens}) {
    padding: ${(props) => (props.recommendationsActive ? '20px 10% 0px' : '20px 10% 50px')};
  }
  @media (max-height: ${extraSmallScreens}) {
    padding: ${(props) => (props.recommendationsActive ? '10px 10% 0px' : '10px 10%')};
  }
`;

export const SectionContainer = styled.div`
  display: inline-block;
`;

export const ResultRow = styled.div`
  color: #000;
  cursor: pointer;
  border-bottom: 0.1rem solid #d8e8ef;
  text-align: left;
  padding: 15px 0px;
  line-height: 1.42857;
  vertical-align: top;
  font-weight: 300;
  width: 100%;
  &:hover {
    color: #7f7f7f;
  }
`;

ResultRow.displayName = 'ResultRow';

export const PreSelectionSection = styled.div`
  padding: ${(props) => (props.showUnderline ? '0px 0px 0px' : '0px 0px 40px')};
  display: block;
  margin-bottom: 50px;
  border-bottom: ${(props) => (props.showUnderline ? '1px solid #dadee8' : 'none')};
  text-align: center;
  width: 100%;
  @media (min-width: 1700px) {
    padding: ${(props) => (props.showUnderline ? '0px 0px 0px' : '0px 0px 40px')};
  }
`;

export const SimilarTicketSection = styled.div`
  padding: 0px 30px 0px;
  @media (max-height: ${smallScreens}) {
    padding: 0px 10px;
  }
`;

export const Title = styled.p`
  padding: 0px 30px;
  font-family: 'Lato-Bold';
  margin-bottom: 20px;
  text-align: center;
  font-size: 16px;
  color: ${colors.black1};
  @media screen and (max-width: ${smallScreens}), screen and (max-height: ${extraSmallScreens}) {
    font-size: 12px;
    margin-bottom: 10px;
  }
`;

export const SubText = styled.p`
  padding: 0px 30px;
  font-family: 'Lato';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 13px;
  color: ${colors.lightBlack};
  @media screen and (max-width: ${smallScreens}), screen and (max-height: ${smallScreens}) {
    font-size: 10px;
  }
`;

export const RecommendationTitle = styled(Title)`
  font-size: 12px;
  margin-bottom: 10px;
  color: ${colors.purple1};
  @media screen and (max-width: ${smallScreens}), screen and (max-height: ${smallScreens}) {
    font-size: 11px;
  }
`;

export const RecommendationSubText = styled(SubText)`
  font-size: 13px;
  color: ${colors.lightBlack};
  @media screen and (max-width: ${smallScreens}), screen and (max-height: ${smallScreens}) {
    font-size: 10px;
  }
`;
